<template>
  <div class="w-full pt-5">
    <div v-if="hasModuleAccess">
      <template>
        <div class="flex items-center">
          <div class="border-r border-romanSilver h-6 flex">
            <BackButton
              label="Back"
              @onClick="goBackToDirectReport()"
              variant="secondary"
              class="ml-2"
            />
          </div>
          <h1 class="text-xl text-left font-extrabold mx-4">
            Employee Appraisal
          </h1>
          <Breadcrumb :items="breadcrumbs" />
        </div>
      </template>

      <template v-if="isLoading">
        <div class="mt-20 h-full">
          <Loader size="xxs" :loader-image="false" />
        </div>
      </template>

      <template v-else>
        <template>
          <Card class="px-5 py-2 flex flex-col m-5">
            <div class="flex justify-between items-center m-1">
              <div
                class="flex gap-2 mb-2 font-bold text-sm leading-6 tracking-normal"
              >
                <span class="uppercase text-romanSilver">Employee:</span>
                <span class="capitalize text-darkPurple">{{
                  employees[0].name
                }}</span>
              </div>
            </div>
            <div class="flex gap-5">
              <div class="flex-1 w-2/12 rounded-md">
                <img
                  v-if="
                    employees[0].photo !== '' && employees[0].photo !== null
                  "
                  :src="employees[0].photo"
                  alt="profile"
                  style="border-radius: 8px"
                />
                <div
                  style="height: 137px; width: 183px; border-radius: 5px"
                  class="text-blueCrayola border text-center font-black text-lg pt-14 mr-2"
                  v-else
                >
                  {{ $getInitials(`${employees[0].name}`) }}
                </div>
              </div>
              <div class="flex flex-col flex-3 w-10/12">
                <div class="flex mb-2 w-full gap-2">
                  <div
                    class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                  >
                    <Icon
                      class-name="text-romanSilver"
                      size="xs"
                      icon-name="calendar"
                    />
                    <div class="flex flex-col tracking-wide font-bold">
                      <span class="text-xs text-carrotOrange uppercase"
                        >Designation</span
                      >
                      <span class="text-sm text-jet uppercase">{{
                        employees[0].designation
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                  >
                    <Icon
                      class-name="text-romanSilver"
                      size="xs"
                      icon-name="icon-department"
                    />
                    <div class="flex flex-col tracking-wide font-bold">
                      <span class="text-xs text-blueCrayola uppercase"
                        >Function</span
                      >
                      <span class="text-sm text-jet uppercase">{{
                        employees[0].function
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                  >
                    <Icon
                      class-name="text-romanSilver"
                      size="xs"
                      icon-name="user"
                    />
                    <div class="flex flex-col tracking-wide font-bold">
                      <span class="text-xs text-mediumSeaGreen uppercase"
                        >Line Manager</span
                      >
                      <span
                        class="text-sm text-jet uppercase whitespace-nowrap"
                        >{{ employees[0].manager }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="flex mb-4 w-full gap-2">
                  <div
                    class="flex flex-1 p-3 shadow rounded-md gap-2 items-start w-1/3"
                  >
                    <Icon
                      class-name="text-romanSilver"
                      size="xs"
                      icon-name="icon-user-list"
                    />
                    <div class="flex flex-col tracking-wide font-bold">
                      <span class="text-xs text-lite uppercase"
                        >Employee ID</span
                      >
                      <span class="text-sm text-jet uppercase">{{
                        employees[0].employeeId
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="flex flex-2 p-3 shadow rounded-md gap-2 items-start w-2/3"
                  >
                    <Icon
                      class-name="text-romanSilver"
                      size="xs"
                      icon-name="pin"
                    />
                    <div class="flex flex-col tracking-wide font-bold">
                      <span class="text-xs text-flame uppercase"
                        >Office Location</span
                      >
                      <span class="text-sm text-jet uppercase">{{
                        employees[0].office
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </template>
        <template>
          <div class="mx-5 mt-10">
            <Tab
              class="mt-6 mx-3"
              :tabs="tabsItems"
              :active-tab="activeTab"
              @currentTab="activateTab($event)"
              :border="true"
            />

            <StatusReportView v-if="activeTab === 'Status Overview'" />

            <div v-if="startAppraisal && activeTab !== 'Status Overview'">
              <!---- OTHER APPRAISAL BLOCK-->
              <template v-if="!finalAppraisal">
                <div class="mt-20 h-full" v-if="loadingAppraisal">
                  <Loader size="xxs" :loader-image="false" />
                </div>

                <div class="w-full flex flex-col" v-else>
                  <div
                    class="w-full flex flex-row justify-between"
                    style="margin-top: 20px"
                  >
                    <div class="flex h-auto mt-2">
                      <h1 class="text-base font-bold">KPAs</h1>
                    </div>

                    <div class="w-auto flex items-center gap-2">
                      <div
                        class="w-auto flex cursor-pointer items-center"
                        @click="getEachAgreementComments()"
                      >
                        <Icon
                          icon-name="comment-plus-icon"
                          style="color: white"
                          size="xsm"
                        />
                      </div>
                      <div class="h-4 mx-3 w-px bg-gray-400" />
                      <div
                        class="flex items-center justify-between p-2 bg-ghostWhite rounded"
                      >
                        <span class="text-sm font-black whitespace-nowrap">
                          Total Allocated Weight:
                        </span>
                        <span class="text-sm text-desire ml-2">
                          {{ allocatedWeight }}%
                        </span>
                      </div>

                      <div class="self-stretch w-px bg-gray-400 mx-3"></div>

                      <div
                        class="flex items-center justify-between p-2 bg-ghostWhite rounded"
                      >
                        <span class="text-sm font-semibold">
                          {{ approvedScore || "---" }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="w-full h-px bg-gray-300 my-4"></div>

                  <!--- List of KPAs-->

                  <div class="w-full h-auto flex flex-col">
                    <accordion
                      class="mt-6"
                      v-for="(kpaTypes, kpaNumber) in templateKPATypes"
                      :key="'kpa-' + kpaNumber"
                      show-divider
                      :is-open="true"
                    >
                      <template v-slot:title>
                        <span class="font-bold">{{ kpaTypes.name }}</span>
                      </template>

                      <template v-slot:block>
                        <div class="w-auto flex items-center">
                          <div class="w-auto flex items-center">
                            <Icon
                              icon-name="comment-plus-icon"
                              style="color: white"
                              size="xsm"
                            />
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div class="w-auto flex items-center">
                            <img
                              src="@/assets/images/hugeicons_assignments.svg"
                              style="width: 24px; height: 24px"
                            />
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div
                            class="py-1 px-2 w-auto flex gap-2 items-center bg-gray-50 shadow-sm rounded-sm"
                          >
                            <span class="font-black text-xs">
                              {{ kpaTypes.weight }}%
                            </span>
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div
                            class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2"
                          >
                            <span class="font-black text-xs">
                              {{ kpaTypeScores[kpaTypes.id] || "---" }}
                            </span>
                          </div>
                        </div>
                      </template>

                      <div class="flex flex-col w-full -mt-3">
                        <div class="w-full gap-6 flex flex-col">
                          <accordion
                            class="px-5 bg-gray-50 shadow-md rounded-lg -mt-1 mb-0"
                            v-for="(item, index) in kpaTypes.kpas"
                            :key="'kpi-' + index"
                            :iconClass="'mt-2'"
                            :is-open="true"
                          >
                            <template v-slot:block>
                              <div
                                class="w-full flex items-center mt-2 justify-between"
                              >
                                <div class="w-auto flex">
                                  <div class="w-auto flex gap-2">
                                    <span class="font-bold text-flame text-sm"
                                      >KPI :</span
                                    >
                                    <span class="font-semibold text-sm">{{
                                      item.data?.name || item.name
                                    }}</span>
                                  </div>

                                  <div class="w-auto mx-4 flex gap-1">
                                    <span class="w-[1px] h-full border" />
                                  </div>

                                  <div class="w-auto flex gap-2">
                                    <span class="font-bold text-flame text-sm"
                                      >Objective :</span
                                    >
                                    <span class="font-semibold text-sm">{{
                                      item.data?.objective || item.objective
                                    }}</span>
                                  </div>
                                </div>

                                <div class="w-auto flex items-center">
                                  <div
                                    class="flex cursor-pointer items-center"
                                    @click="
                                      getEachAgreementComments(item.kpaId)
                                    "
                                  >
                                    <Icon
                                      icon-name="comment-plus-icon"
                                      style="color: white"
                                      size="xsm"
                                    />
                                  </div>

                                  <div
                                    :class="'h-6'"
                                    class="w-auto mx-4 flex items-center"
                                  >
                                    <span class="w-px bg-gray-300 h-6"></span>
                                  </div>

                                  <div
                                    class="flex cursor-pointer items-center"
                                    @click="viewReport(item, kpaTypes)"
                                  >
                                    <img
                                      v-if="
                                        item.report === null ||
                                        item.report === 'null'
                                      "
                                      src="@/assets/images/hugeicons_assignments-gray.svg"
                                      style="width: 24px; height: 24px"
                                    />
                                    <img
                                      v-else
                                      src="@/assets/images/hugeicons_assignments.svg"
                                      style="width: 24px; height: 24px"
                                    />
                                  </div>
                                  <div
                                    :class="'h-6'"
                                    class="w-auto mx-4 flex items-center"
                                  >
                                    <span class="w-px bg-gray-300 h-6"></span>
                                  </div>
                                  <div
                                    class="px-2 py-1 w-auto flex gap-2 items-center rounded-sm mt-1"
                                  >
                                    <span class="font-black text-xs">
                                      {{ item.data?.weight || item.weight }}%
                                    </span>
                                  </div>

                                  <div class="h-4 mx-2 w-px bg-gray-400" />

                                  <div
                                    class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2"
                                  >
                                    <span class="font-black text-xs">
                                      <!-- {{ item.approvedFlag }} -->
                                      {{
                                        getReviewType() === "final_review"
                                          ? item.approvedScore
                                          : item.approvedFlag || "---"
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <div
                              class="w-full h-[1px] mb-6 -mt-3 border border-2"
                            />

                            <!-- Labels row -->
                            <div
                              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full mb-3"
                            >
                              <!-- KPI Criteria List -->
                              <div
                                class="flex flex-col"
                                v-for="(n, rating) in item.data?.kpis ||
                                item.kpis"
                                :key="rating"
                              >
                                <span
                                  v-if="rating === 0"
                                  class="text-sm font-semibold mb-1"
                                  >Criteria</span
                                >
                                <span v-else class="mb-1">&nbsp;</span>
                                <c-text
                                  variant="w-full"
                                  class="mr-2 -mt-2"
                                  :disabled="true"
                                  :value="n.criteria"
                                />
                              </div>

                              <!-- Employee Self Rating -->
                              <div class="flex flex-col">
                                <span class="text-sm font-semibold mb-1"
                                  >Employee Self-Appraisal</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2 w-full"
                                    type="number"
                                    :disabled="true"
                                    :options="activeRatingOptions"
                                    v-model="item.selfRating"
                                  />
                                </div>
                              </div>

                              <!-- Line Manager Rating -->
                              <div class="flex flex-col">
                                <span class="text-sm font-semibold mb-1"
                                  >Direct Line Manager</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2 w-full"
                                    type="number"
                                    :disabled="true"
                                    :options="activeRatingOptions"
                                    v-model="item.ratingId"
                                  />
                                </div>
                              </div>

                              <!-- Dotted Line Manager Rating -->
                              <div
                                class="flex flex-col"
                                v-if="dottedReportingAppraisal"
                              >
                                <span class="text-sm font-semibold mb-1"
                                  >Dotted Line Manager</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2 w-full"
                                    type="number"
                                    :disabled="true"
                                    :options="activeRatingOptions"
                                    v-model="item.dottedLineManagerRating"
                                  />
                                </div>
                              </div>
                            </div>
                          </accordion>
                        </div>
                      </div>
                    </accordion>
                  </div>

                  <!----<div class="flex flex-col w-full" v-if="loaded">
                    <template>
                      <div
                        class="w-full flex p-5 shadow rounded-md my-2 justify-between items-center relative text-right whitespace-nowrap">
                        <span class="font-bold text-lg leading-5 text-left text-darkPurple tracking-wider">
                          Summary
                        </span>
                        <div class="absolute left-0 right-0 border border-solid border-gray-400 h-0 ml-36 mr-52" />
                        <div class="flex justify-end gap-10 bg-white relative px-5">
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">Appraisal Flag</span>
                            <span class="font-semibold text-base text-darkPurple">{{ approvedScore }}</span>
                          </div>
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">self-appraisal</span>
                            <span class="font-semibold text-base text-darkPurple">{{ selfAppraisalScore }}</span>
                          </div>
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">line manager</span>
                            <span class="font-semibold text-base text-darkPurple">{{ lineManagerAppraisalScore }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>-->
                </div>
              </template>

              <!---- FINAL APPRAISAL BLOCK-->
              <template v-else>
                <div class="mt-20 h-full" v-if="loadingAppraisal">
                  <Loader size="xxs" :loader-image="false" />
                </div>

                <div class="w-full flex flex-col" v-else>
                  <div
                    class="w-full flex flex-row justify-between"
                    style="margin-top: 20px"
                  >
                    <div class="flex h-auto mt-2">
                      <h1 class="text-base font-bold">KPAs</h1>
                    </div>

                    <div class="w-auto flex items-center gap-2">
                      <div
                        class="w-auto flex cursor-pointer items-center"
                        @click="getEachAgreementComments()"
                      >
                        <Icon
                          icon-name="comment-plus-icon"
                          style="color: white"
                          size="xsm"
                        />
                      </div>
                      <div
                        class="flex items-center justify-between p-2 bg-ghostWhite rounded"
                      >
                        <span class="text-sm font-black whitespace-nowrap">
                          Total Allocated Weight:
                        </span>
                        <span class="text-sm text-desire ml-2">
                          {{ allocatedWeight }}%
                        </span>
                      </div>

                      <div class="self-stretch w-px bg-gray-400 mx-3"></div>

                      <div
                        class="flex items-center justify-between p-2 bg-ghostWhite rounded"
                      >
                        <span class="text-sm font-semibold">
                          {{ approvedScore || "---" }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="w-full h-px bg-gray-300 my-4"></div>

                  <!--- List of KPAs-->

                  <div class="w-full h-auto flex flex-col">
                    <accordion
                      class="mt-6"
                      v-for="(kpaTypes, kpaNumber) in templateKPATypes"
                      :key="'kpa-' + kpaNumber"
                      show-divider
                      :is-open="true"
                    >
                      <template v-slot:title>
                        <span class="font-bold">{{ kpaTypes.name }}</span>
                      </template>

                      <template v-slot:block>
                        <div class="w-auto flex items-center">
                          <div class="w-auto flex items-center">
                            <Icon
                              icon-name="comment-plus-icon"
                              style="color: white"
                              size="xsm"
                            />
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div class="w-auto flex items-center">
                            <img
                              src="@/assets/images/hugeicons_assignments.svg"
                              style="width: 24px; height: 24px"
                            />
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div
                            class="py-1 px-2 w-auto flex gap-2 items-center bg-gray-50 shadow-sm rounded-sm"
                          >
                            <span class="font-black text-xs">
                              {{ kpaTypes.weight }}%
                            </span>
                          </div>

                          <div class="h-4 mx-2 w-px bg-gray-400" />

                          <div
                            class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2"
                          >
                            <span class="font-black text-xs">
                              {{
                                getKPATotalScore(kpaTypes.kpas) === ""
                                  ? "---"
                                  : getKPATotalScore(kpaTypes.kpas)
                              }}
                            </span>
                          </div>
                        </div>
                      </template>

                      <div class="flex flex-col w-full -mt-3">
                        <div
                          class="w-full bg-gray-50 shadow-md rounded-lg flex flex-col"
                        >
                          <accordion
                            class="px-5 -mt-1 mb-0"
                            v-for="(item, index) in kpaTypes.kpas"
                            :key="'kpi-' + index"
                            :iconClass="'mt-2'"
                            :is-open="false"
                          >
                            <template v-slot:block>
                              <div
                                class="w-full flex items-center mt-2 justify-between"
                              >
                                <div class="w-auto flex">
                                  <div class="w-auto flex gap-2">
                                    <span class="font-bold text-flame text-sm"
                                      >KPI :</span
                                    >
                                    <span class="font-semibold text-sm">{{
                                      item.data?.name || item.name
                                    }}</span>
                                  </div>

                                  <div class="w-auto mx-4 flex gap-1">
                                    <span class="w-[1px] h-full border" />
                                  </div>

                                  <div class="w-auto flex gap-2">
                                    <span class="font-bold text-flame text-sm"
                                      >Objective :</span
                                    >
                                    <span class="font-semibold text-sm">{{
                                      item.data?.objective || item.objective
                                    }}</span>
                                  </div>
                                </div>

                                <div class="w-auto flex items-center">
                                  <div class="h-4 mx-2 w-px bg-gray-400" />

                                  <div
                                    class="flex cursor-pointer items-center"
                                    @click="
                                      getEachAgreementComments(item.kpaId)
                                    "
                                  >
                                    <Icon
                                      icon-name="comment-plus-icon"
                                      style="color: white"
                                      size="xsm"
                                    />
                                  </div>

                                  <div
                                    :class="'h-6'"
                                    class="w-auto mx-4 flex items-center"
                                  >
                                    <span class="w-px bg-gray-300 h-6"></span>
                                  </div>

                                  <div
                                    class="flex cursor-pointer items-center"
                                    @click="viewReport(item, kpaTypes)"
                                  >
                                    <img
                                      v-if="
                                        item.report === null ||
                                        item.report === 'null'
                                      "
                                      src="@/assets/images/hugeicons_assignments-gray.svg"
                                      style="width: 24px; height: 24px"
                                    />
                                    <img
                                      v-else
                                      src="@/assets/images/hugeicons_assignments.svg"
                                      style="width: 24px; height: 24px"
                                    />
                                  </div>
                                  <div
                                    :class="'h-6'"
                                    class="w-auto mx-4 flex items-center"
                                  >
                                    <span class="w-px bg-gray-300 h-6"></span>
                                  </div>

                                  <div
                                    class="px-2 py-1 w-auto flex gap-2 bg-white shadow-sm items-center rounded-sm mt-1"
                                  >
                                    <span class="font-black text-xs">
                                      {{ item.data?.weight || item.weight }}%
                                    </span>
                                  </div>

                                  <div class="h-4 mx-2 w-px bg-gray-400" />

                                  <div
                                    class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2"
                                  >
                                    <span class="font-black text-xs">
                                      <!-- {{
                                        item.approvedScore
                                      }} -->
                                      {{
                                        getReviewType() === "final_review"
                                          ? item.approvedScore
                                          : item.approvedFlag || "---"
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <div
                              class="w-full h-[1px] mb-6 -mt-3 border border-2"
                            />

                            <!-- Labels row -->
                            <div
                              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full mb-3"
                            >
                              <!-- KPI Criteria List -->
                              <div
                                class="flex flex-col"
                                v-for="(n, rating) in item.data?.kpis ||
                                item.kpis"
                                :key="rating"
                              >
                                <span
                                  v-if="rating === 0"
                                  class="text-sm font-semibold mb-1"
                                  >Criteria</span
                                >
                                <span v-else class="mb-1">&nbsp;</span>
                                <c-text
                                  variant="w-full"
                                  class="mr-2 -mt-2"
                                  :disabled="true"
                                  :value="n.criteria"
                                />
                              </div>

                              <!-- Employee Self Rating -->
                              <div class="flex flex-col">
                                <span class="text-sm font-semibold mb-1"
                                  >Employee Self-Appraisal</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2"
                                    type="number"
                                    :disabled="true"
                                    :options="ratingOptions"
                                    v-model="item.selfRating"
                                  />
                                </div>
                              </div>

                              <!-- Line Manager Rating -->
                              <div class="flex flex-col">
                                <span class="text-sm font-semibold mb-1"
                                  >Line Manager 1 Appraisal</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2"
                                    type="number"
                                    :disabled="true"
                                    :options="ratingOptions"
                                    v-model="item.managerRating"
                                  />
                                </div>
                              </div>

                              <!-- Dotted Line Manager Rating -->
                              <div
                                class="flex flex-col"
                                v-if="dottedReportingAppraisal"
                              >
                                <span class="text-sm font-semibold mb-1"
                                  >Dotted Line Manager</span
                                >
                                <div class="w-full flex bg-white">
                                  <c-select
                                    placeholder="--Rating--"
                                    variant="w-full"
                                    class="-mt-2 w-full"
                                    type="number"
                                    :disabled="true"
                                    :options="activeRatingOptions"
                                    v-model="item.dottedLineManagerRating"
                                  />
                                </div>
                              </div>
                            </div>
                          </accordion>
                        </div>
                      </div>
                    </accordion>
                  </div>

                  <!----<div class="flex flex-col w-full" v-if="loaded">
                    <template>
                      <div
                        class="w-full flex p-5 shadow rounded-md my-2 justify-between items-center relative text-right whitespace-nowrap">
                        <span class="font-bold text-lg leading-5 text-left text-darkPurple tracking-wider">
                          Final Score
                        </span>
                        <div class="absolute left-0 right-0 border border-solid border-gray-400 h-0 ml-36 mr-52" />
                        <div class="flex justify-end gap-10 bg-white relative px-5">
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">Approved Score</span>
                            <span class="font-semibold text-base text-darkPurple">{{ approvedScore }}</span>
                          </div>
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">self-appraisal</span>
                            <span class="font-semibold text-base text-darkPurple">{{ selfAppraisalScore }}</span>
                          </div>
                          <div class="flex flex-col items-start leading-5">
                            <span class="text-gray-400 text-xs text-center font-black uppercase">line manager</span>
                            <span class="font-semibold text-base text-darkPurple">{{
                              lineManagerAppraisalScore }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>-->
                </div>
              </template>
            </div>

            <div class="w-full" v-if="appraisalMessage !== ''">
              <div
                class="w-full flex flex-col justify-center items-center mt-20"
              >
                <icon
                  icon-name="empty_agreement"
                  size="l"
                  style="width: 300px"
                />
                <div class="w-1/2 text-base text-center">
                  {{ appraisalMessage }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <template>
        <RightSideBar
          v-if="isOpenComments"
          @submit="sendComment"
          :disabled-button="isSavingComment"
          @close="(isOpenComments = false), (senderkpaId = ''), (comment = '')"
          button-class="bg-dynamicBackBtn text-white"
        >
          <template v-slot:title>
            <p class="text-darkPurple font-bold text-lg leading-5 p-0">
              Comments
            </p>
          </template>
          <div class="w-full flex mb-7">
            <div class="flex flex-col w-full" style="min-height: 70vh">
              <CommentsBox
                :comments="allComments"
                :senderId="senderId"
                @markRead="markAsRead($event)"
                @deleteComment="deleteComments($event)"
                :loading="loadComments"
              />
              <div class="-mb-12" style="margin-top: auto">
                <CTextarea
                  placeholder="--Message--"
                  variant="primary"
                  class="mt-2 rounded-lg"
                  value=""
                  :row="8"
                  :height="90"
                  :col="30"
                  :input="null"
                  v-model="comment"
                />
              </div>
            </div>
          </div>
        </RightSideBar>

        <RightSideBar
          v-if="statusModal"
          @close="statusModal = false"
          :closeButton="true"
          button-class="bg-dynamicBackBtn text-white"
          :disabled-button="isSavingReport"
        >
          <template v-slot:title>
            <div class="w-full flex justify-between items-center">
              <span class="text-darkPurple font-bold text-lg leading-5 p-0"
                >Report New</span
              >
            </div>
          </template>
          <StatusReport
            :kpasItem="kpasItem"
            :kpaTypes="kpaTypes"
            :edit="true"
            :isView="true"
          />
        </RightSideBar>
      </template>
    </div>
    <div v-else>
      <ErrorComponent />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Card from "@scelloo/cloudenly-ui/src/components/card";
import ScrollContainer from "@/components/ScrollContainer";
import Loader from "@/components/Loader";
import Accordion from "@/components/Accordion";
import Table from "@/components/Table";
import Icon from "@/components/Icon";
import RightSideBar from "@/components/RightSideBar";
import StatusReport from "@/components/StatusReport";
import CommentsBox from "@/components/commentsBox";
import paramsMixin from "@/utilities/paramsMixin";
import timeFormatMixin from "@/utilities/timeFormatMixin";
import ErrorComponent from "@/modules/Admin/error403";
import StatusReportView from "./StatusReport";

export default {
  name: "PerformanceEmployeeAppraisals",
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    Tab,
    ErrorComponent,
    Breadcrumb,
    StatusReport,
    StatusReportView,
    BackButton,
    CSelect,
    CommentsBox,
    ScrollContainer,
    CText,
    Loader,
    Card,
    Accordion,
    Table,
    Icon,
    CTextarea,
    RightSideBar,
  },
  data() {
    return {
      hasModuleAccess: false,
      openModal: false,
      isLoading: true,
      statusModal: false,
      loaded: false,
      isOpenComments: false,
      loadComments: true,
      isManager: false,
      loadingAppraisal: true,
      tabsItems: [],
      activeTab: `${this.$route.params.cycle}`,
      KPAHeader: [
        { title: "KPA", value: "name" },
        { title: "Objective", value: "objective" },
        { title: "KPI", value: "kpis" },
        { title: "Weight (%)", value: "weight" },
      ],
      breadcrumbs: [
        {
          disabled: false,
          text: "Performance",
          href: "Performance",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Performance Appraisals",
          href: "performance-appraisals",
          id: "PerformanceAppraisals",
        },
        {
          disabled: false,
          text: "Employee Appraisal",
          href: "employee-appraisal",
          id: "EmployeeAppraisal",
        },
      ],
      startAppraisal: false,
      appraisalStartDate: "",
      appraisalEndDate: "",
      appraisalMessage: "",
      appraisalEnd: false,
      templateKPATypes: [],
      Ratings: [],
      ratingOptions: [],
      flagOptions: [],
      employeeAppraisals: [],
      selfAppraisalScore: "",
      lineManagerAppraisalScore: "",
      approvedScore: "",
      appraisalStatus: "",
      appraisalFlag: "",
      appraisalState: "",
      appraisalAgreed: "",
      checkEditAppraisal: false,
      disableAppraisal: false,
      appraisalDisplay: "",
      employee: false,
      finalAppraisal: false,
      cyclesArr: [],
      allocatedWeight: 0,
      allComments: [],
      comment: "",
      employees: [],
      midTermAppraisalStructure: "",
      payload: {
        employeeAgreementId: "",
        orgId: null,
        goalId: null,
        year: "",
        employeeId: "",
        appraisal_status: "",
        status: "draft",
        cycleId: "",
        appraisalFor: "",
        appraisalBy: "",
        share: false,
        reviewType: "",
        kpa_types: [],
      },
      kpaTypeManagerScores: {},
      directReportYear: `${this.$route.params.directReportYear}`,
      directReportId: `${this.$route.params.directReportId}`,
      QAppraisal: `${this.$route.params.QAppraisal}`,
      hasDottedReporting: false,
      dottedReportingAppraisal: false,
      isSavingComment: false,
      isSavingReport: false,
    };
  },

  computed: {
    activeRatingOptions() {
      if (!this.finalAppraisal) {
        if (this.midTermAppraisalStructure === "regular_ratings") {
          return this.ratingOptions;
        }
        return this.flagOptions;
      }
      return this.ratingOptions;
    },
    kpaTypeScores() {
      const scores = {};

      this.templateKPATypes.forEach((kpaType) => {
        if (!kpaType.kpas || kpaType.kpas.length === 0) {
          scores[kpaType.id] = "---";
          return;
        }

        // Check if any KPA has null managerScore and dottedLineManagerScore
        if (
          kpaType.kpas.some(
            (item) =>
              item.managerScore == null && item.dottedLineManagerScore == null
          )
        ) {
          scores[kpaType.id] = "---";
          return;
        }

        // ✅ Compute based on availability
        const totalScore = kpaType.kpas.reduce((sum, item) => {
          const hasManager = item.managerScore != null;
          const hasDotted = item.dottedLineManagerScore != null;

          if (hasManager && hasDotted) {
            return (
              sum +
              (parseFloat(item.managerScore) || 0) +
              (parseFloat(item.dottedLineManagerScore) || 0)
            );
          }
          if (hasManager) {
            return sum + (parseFloat(item.managerScore) || 0);
          }
          if (hasDotted) {
            return sum + (parseFloat(item.dottedLineManagerScore) || 0);
          }
          return sum;
        }, 0);

        const totalWeight = kpaType.kpas.reduce((sum, item) => {
          return sum + (parseFloat(item.weight) || 0);
        }, 0);

        if (this.getReviewType() !== "mid_review") {
          if (this.hasDottedReporting) {
            scores[kpaType.id] = (totalScore / 2).toFixed(2);
          } else {
            scores[kpaType.id] = totalScore.toFixed(2);
          }
        } else if (this.kpaTypeManagerScores[kpaType.id] !== undefined) {
          scores[kpaType.id] = this.kpaTypeManagerScores[kpaType.id];
        } else {
          let weightedScore;

          if (this.hasDottedReporting && this.dottedReportingAppraisal) {
            weightedScore = totalScore / 2;
          } else {
            weightedScore = totalScore;
          }

          const totalWeightedScore = (weightedScore / totalWeight) * 100;

          // 🔄 async update in background
          this.calculateAndCacheScore(totalWeightedScore, kpaType.id);

          scores[kpaType.id] = "Loading...";
        }
      });

      return scores;
    },
  },

  methods: {
    getReviewType() {
      if (!this.finalAppraisal) {
        if (this.midTermAppraisalStructure === "regular_ratings") {
          return "final_review";
        }
        return "mid_review";
      }
      return "final_review";
    },

    async activateTab(tab) {
      if (tab === "Status Overview") {
        this.activeTab = tab;
        return;
      }
      if (!this.tabsItems.length) {
        await this.getCycleTabs();
      }
      const tabIndex = this.tabsItems.indexOf(tab, 0);

      if (tabIndex === this.tabsItems.length - 2) {
        this.finalAppraisal = true;
        this.payload.reviewType = "final_review";
      } else {
        this.finalAppraisal = false;
        this.payload.reviewType = "mid_review";
      }

      this.cyclesArr.filter((cycle) => {
        if (cycle.name === tab) {
          this.payload.cycleId = cycle.id;
        }
        return {};
      });

      this.employeeAppraisals = [];
      this.templateKPATypes = [];
      this.loaded = false;
      this.loadingAppraisal = true;
      this.startAppraisal = false;
      this.appraisalMessage = "";
      this.appraisalEnd = false;

      this.$_getAppraisalCycle(this.appraisalQuery()).then((response) => {
        const appraisal = response.data.AppraisalCycle;

        appraisal[0].cycles.map((cycle) => {
          this.cyclesArr.push({
            id: cycle.id,
            name: cycle.name,
          });

          if (cycle.name === this.activeTab) {
            this.appraisalStartDate = this.setDates(cycle.appraisal_starts);
            this.appraisalEndDate = this.setDates(cycle.appraisal_ends);

            this.checkAppraisalStart();
          }
          return {};
        });
      });

      this.activeTab = tab;
    },

    changeRating(event, item, kpaTypes) {
      const ratingId = event.target.value;
      const { kpaId } = item.data;
      let sum = 0;
      this.$_calculateRatingScore(kpaId, ratingId).then((response) => {
        // eslint-disable-next-line no-param-reassign
        item.data.selfScore = response.data.data.score;
        kpaTypes.forEach((type) => {
          type.kpas.forEach((items) => {
            sum += Number(items.selfScore);
            return {};
          });
          return {};
        });
        this.selfAppraisalScore = sum.toFixed(2);
      });
    },

    changeManagerRating(event, item, kpaTypes) {
      const ratingId = event.target.value;
      const { kpaId } = item.data;
      let sum = 0;
      this.$_calculateRatingScore(kpaId, ratingId).then((response) => {
        // eslint-disable-next-line no-param-reassign
        item.data.managerScore = response.data.data.score;
        kpaTypes.forEach((type) => {
          type.kpas.forEach((items) => {
            sum += Number(items.managerScore);
            return {};
          });
          this.lineManagerAppraisalScore = sum.toFixed(2);
          return {};
        });
      });
    },

    async calculateAndCacheScore(weightedScore, kpaTypeId) {
      try {
        const flag = await this.getAverageAppraisal(weightedScore);
        this.$set(this.kpaTypeManagerScores, kpaTypeId, flag || "---");
      } catch (error) {
        this.$set(this.kpaTypeManagerScores, kpaTypeId, "---");
      }
    },

    async getAverageAppraisal(score) {
      try {
        const { data } = await this.$_getScoreAppraisalFlag(score);
        return data.ranking.flag.name;
      } catch (error) {
        return "---";
      }
    },

    getKPATotalScore(kpas) {
      let sum = 0;
      kpas.map((items) => {
        if (items.selfScore !== "") {
          sum += Number(items.selfScore);
        }
        return {};
      });

      if (sum >= 0) {
        return sum.toFixed(2);
      }
      return "";
    },

    getKPATotalManagerScore(kpas) {
      let sum = 0;
      kpas.map((items) => {
        if (items.managerScore !== "") {
          sum += Number(items.managerScore);
        }
        return {};
      });
      if (sum >= 0) {
        return sum.toFixed(2);
      }
      return "";
    },

    getKPATotalManagerAppraisal(kpaTypesname) {
      let appraisalVal;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.cycle === this.activeTab) {
          appraisal.summary.filter((summary) => {
            if (summary.kpaTypeName === kpaTypesname) {
              appraisalVal = summary.managerFlag;
            }
            return {};
          });
        }
        return {};
      });

      return appraisalVal || "---";
    },

    getKPATotalSelfAppraisal(kpaTypesname) {
      let appraisalVal;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.cycle === this.activeTab) {
          appraisal.summary.filter((summary) => {
            if (summary.kpaTypeName === kpaTypesname) {
              appraisalVal = summary.employeeFlag;
            }
            return {};
          });
        }
        return {};
      });
      return appraisalVal || "---";
    },

    submitAppraiser(state, finalAppraisal) {
      const kpaData = [];
      const validateKPA = [];
      this.payload.orgId = this.$orgId;
      this.payload.appraisal_status = "pending";
      this.payload.year = this.$route.params.year;
      this.payload.employeeId = this.$route.params.userId;
      this.payload.appraisalFor = this.$route.params.userId;

      if (finalAppraisal) {
        this.payload.appraisal_agreement = "employee_agreed";
      }

      if (state === "draft") {
        this.payload.status = state;
      } else {
        this.payload.status = "active";
        this.payload.share = true;
      }
      this.templateKPATypes.forEach((kpaType) => {
        const newKPAs = kpaType.kpas.map(
          ({
            name,
            objective,
            kpis,
            weight,
            selfRating,
            selfScore,
            managerRating,
            managerScore,
            ...rest
          }) => ({
            ...rest,
          })
        );
        const validation = newKPAs.every((item) => item.ratingId);
        validateKPA.push(validation);
        kpaData.push({
          kpa_types_id: kpaType.id,
          kpas: newKPAs,
        });
      });

      if (validateKPA.every((valid) => valid === true)) {
        this.payload.kpa_types = kpaData;
        this.$_setManagerAppraisal(this.payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.$router.back();
          })
          .catch((err) => {
            this.$toasted.error(err.response.data.message, { duration: 5000 });
          });
      } else {
        this.$toasted.error("No scores set for each KPA", { duration: 5000 });
      }
    },

    checkSelected(value) {
      if (value === "Approve") {
        this.approveAppraisal();
      } else {
        this.submitAppraiser("active", this.finalAppraisal);
      }
    },

    approveAppraisal() {
      const requestPayload = {
        appraisalId: this.payload.appraisalId,
        appraisal_status: "submitted",
      };
      this.$_approveAppraisal(requestPayload)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.$router.back();
        })
        .catch((err) => {
          this.$toasted.error(err.response.data.message, { duration: 5000 });
        });
    },

    getUserDetails() {
      this.$_getOneEmployeeAll({
        id: this.$route.params.userId,
      }).then((response) => {
        this.employees.push({
          id: response.data.userId,
          name: `${response.data.fname} ${response.data.lname}`,
          photo: response.data.photo,
          designation: response.data.userDesignation.name,
          function: response.data.orgFunction.name,
          manager: `${response.data.userReportingTo.fname} ${response.data.userReportingTo.lname}`,
          employeeId: response.data.employeeId,
          office: response.data.employeeOffice?.name,
        });

        this.isLoading = false;
      });
    },

    getEmployeeAppraisal() {
      this.employeeAppraisals = [];
      this.selfAppraisalScore = "";
      this.lineManagerAppraisalScore = "";
      this.approvedScore = "";

      this.$_getEmployeeAppraisal(this.$route.params.userId).then((result) => {
        const responseData = result.data.EmployeeAppraisal;

        responseData.forEach((response) => {
          if (response.appraisal.current_cycle) {
            if (this.finalAppraisal) {
              if (response.appraisal.current_cycle.name === this.activeTab) {
                this.selfAppraisalScore = response.appraisal.self_score;
                this.lineManagerAppraisalScore =
                  response.appraisal.manager_score;
                this.approvedScore = response.appraisal.approved_score;
                this.appraisalStatus = response.appraisal.appraisal_status;
                this.appraisalState = response.appraisal.appraisal_state;
                this.payload.appraisalId = response.appraisal.id;
                this.appraisalAgreed = response.appraisal.appraisal_agreement;
              }
            }
            if (!this.finalAppraisal) {
              if (response.appraisal.current_cycle.name === this.activeTab) {
                this.selfAppraisalScore =
                  response.appraisalSummary.employeeFlag;
                this.lineManagerAppraisalScore =
                  response.appraisalSummary.managerFlag;
                this.approvedScore =
                  this.getReviewType() !== "mid_review"
                    ? response.appraisalSummary.managerFlagScore
                    : response.appraisalSummary.managerFlag;
                this.appraisalStatus = response.appraisal.appraisal_status;
                this.appraisalState = response.appraisal.appraisal_state;
                this.payload.appraisalId = response.appraisal.id;
              }
            }

            response.appraisal.performance_scores.map((score) => {
              this.employeeAppraisals.push({
                cycle: response.appraisal.current_cycle.name,
                id: score.kpaId,
                selfRatingPoint: score.selfRatingPoint,
                flagId: score.ranking ? score.ranking.flag.name : "",
                managerFlag: score.manager_ranking
                  ? score.manager_ranking.flag.name
                  : "",
                selfScore: score.selfScore,
                outcome: score.outcome,
                managerRatingPoint: score.managerRatingPoint,
                managerScore: score.managerScore,
                dottedLineManagerRatingPoint:
                  score.dottedLineManagerRatingPoint,
                dottedLineManagerScore: score.dottedLineManagerScore,
                dottedLineManagerFlag: score.dotted_line_manager_ranking
                  ? score.dotted_line_manager_ranking.flag.name
                  : "",
                summary: response.summary,
              });
              return {};
            });
          }
        });

        this.getAgreements();
      });
    },

    formatEmployeeDate(value) {
      let initialDate = "";
      if (value) {
        initialDate = new Date(value).toISOString().replace(/.\d+Z$/g, "");
        return this.$DATEFORMAT(new Date(initialDate), "MMMM dd, yyyy");
      }
      return "";
    },

    async getAgreements() {
      try {
        const { userId, year, goalId } = this.$route.params;
        const response = await this.$_getEmployeeAgreement(userId);

        const myAgreements = response.data.EmployeePerformanceAgreements;

        if (!myAgreements.length) {
          this.loadingAppraisal = false;
          this.isLoading = false;
          return;
        }

        for (const agreement of myAgreements) {
          if (Number(agreement.year) === Number(year)) {
            const agreementKPA = agreement.employee_agreement_kpa;
            this.payload.employeeAgreementId = agreement.id;
            this.payload.goalId = goalId;

            const result = await this.$_getOneTemplate(agreement.templateId);
            this.templateKPATypes = result.data.PerformanceTemplate.kpa_types;

            const totalWeight = this.templateKPATypes.reduce(
              (sum, type) => sum + type.weight,
              0
            );
            this.allocatedWeight = totalWeight;
            // Loop with async/await
            for (const kpaType of this.templateKPATypes) {
              kpaType.kpas = [];
              for (const employeeKpi of agreementKPA) {
                if (employeeKpi.kpaTypeId === kpaType.id) {
                  kpaType.kpas.push({
                    name: employeeKpi.name,
                    objective: employeeKpi.objective,
                    kpaId: employeeKpi.id,
                    kpis: this.getCriteriaData(employeeKpi.kpis_employee),
                    weight: employeeKpi.weight,
                    outcome: this.getOutcome(employeeKpi.id),
                    selfRating: this.getSelfRating(employeeKpi.id),
                    selfScore: this.getScore(employeeKpi.id, employeeKpi),
                    ratingId: this.getRatingId(employeeKpi.id),
                    managerRating: this.getRatingId(employeeKpi.id),
                    managerScore: this.getManagerScore(
                      employeeKpi.id,
                      employeeKpi
                    ),
                    approvedScore: await this.getApprovedScore(employeeKpi.id),
                    approvedFlag: await this.getApprovedFlag(employeeKpi.id),
                    report: employeeKpi.report,
                    ...(this.dottedReportingAppraisal && {
                      dottedLineManagerRating: this.getDottedManagerRating(
                        employeeKpi.id
                      ),
                      dottedLineManagerScore: this.getDottedManagerScore(
                        employeeKpi.id
                      ),
                      dottedLineManagerRatingPoint: this.getDottedRatingPoint(
                        employeeKpi.id
                      ),
                    }),
                  });
                }
              }
            }

            this.loaded = true;
            this.loadingAppraisal = false;
          }
        }

        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      } catch (error) {
        console.error("Error in getAgreements:", error);
        this.loadingAppraisal = false;
        this.isLoading = false;
      }
    },

    async getApprovedScore(kpasid) {
      const appraisal = this.employeeAppraisals.find(
        (a) => a.id === kpasid && a.cycle === this.activeTab
      );

      if (
        !appraisal ||
        (appraisal.managerScore == null &&
          (this.hasDottedReporting
            ? appraisal.dottedLineManagerScore == null
            : true))
      ) {
        return null; // or '---'
      }

      const scores = [];
      if (appraisal.managerScore != null) {
        scores.push(Number(appraisal.managerScore));
      }
      if (appraisal.dottedLineManagerScore != null) {
        scores.push(Number(appraisal.dottedLineManagerScore));
      }

      let score;

      if (scores.length > 1) {
        score = (scores[0] + scores[1]) / 2;
      } else {
        score = this.hasDottedReporting ? scores[0] / 2 : scores[0];
      }

      return score.toFixed(2);
    },

    async getApprovedFlag(kpasid) {
      const appraisal = this.employeeAppraisals.find(
        (a) => a.id === kpasid && a.cycle === this.activeTab
      );

      if (
        !appraisal ||
        (appraisal.managerScore == null &&
          appraisal.dottedLineManagerScore == null)
      ) {
        return null; // or '---'
      }

      const scores = [];
      if (appraisal.managerScore !== null) {
        scores.push(Number(appraisal.managerRatingPoint));
      }
      if (appraisal.dottedLineManagerScore != null) {
        scores.push(Number(appraisal.dottedLineManagerRatingPoint));
      }

      const score =
        scores.length > 1
          ? (scores[0] + scores[1]) / 2 // average if both exist
          : scores[0];

      const { data } = await this.$_getScoreAppraisalFlag(score.toFixed(2));
      return data.ranking.flag.name;
    },
    getDottedManagerRating(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (this.finalAppraisal) {
            return (ratePoint = appraisal.dottedLineManagerRatingPoint);
          }
          if (this.midTermAppraisalStructure === "regular_ratings") {
            ratePoint = appraisal.dottedLineManagerRatingPoint;
          } else {
            ratePoint = appraisal.dottedLineManagerFlag;
          }
        }
      });

      if (this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings") {
        this.ratingOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
        });
      } else {
        this.flagOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
        });
      }
      return rating || "";
    },

    getDottedRatingPoint(kpasid) {
      let ratePoint;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          ratePoint = appraisal.dottedLineManagerRatingPoint;
        }
        return {};
      });

      return ratePoint || "";
    },

    getDottedManagerScore(kpasid) {
      const appraisal = this.employeeAppraisals.find(
        (a) => a.id === kpasid && a.cycle === this.activeTab
      );

      if (!appraisal || appraisal.dottedLineManagerScore == null) {
        return null;
      }

      return Number(appraisal.dottedLineManagerScore).toFixed(2);
    },

    getScore(kpasid) {
      let score;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          score = appraisal.selfScore;
        }
        return {};
      });
      return score || "";
    },

    getSelfRating(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (
            this.finalAppraisal ||
            this.midTermAppraisalStructure === "regular_ratings"
          ) {
            ratePoint = appraisal.selfRatingPoint;
          } else {
            ratePoint = appraisal.flagId;
          }
        }
        return {};
      });
      if (
        this.finalAppraisal ||
        this.midTermAppraisalStructure === "regular_ratings"
      ) {
        this.ratingOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
          return {};
        });
      } else {
        this.flagOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
          return {};
        });
      }
      return rating || "";
    },

    getOutcome(kpasid) {
      let outcome;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          outcome = appraisal.outcome;
        }
        return {};
      });
      return outcome || "";
    },

    getManagerScore(kpasid) {
      let score;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          score = appraisal.managerScore;
        }
        return {};
      });
      return score || "";
    },

    getRatingId(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (
            this.finalAppraisal ||
            this.midTermAppraisalStructure === "regular_ratings"
          ) {
            ratePoint = appraisal.managerRatingPoint;
          } else {
            ratePoint = appraisal.managerFlag;
          }
        }
        return {};
      });
      if (this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings") {
        this.ratingOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
          return {};
        });
      } else {
        this.flagOptions.filter((ratings) => {
          if (ratings.name === ratePoint) {
            rating = ratings.id;
          }
          return {};
        });
      }
      return rating || "";
    },

    getCriteriaData(kpis) {
      const criteriaData = [];
      const sortedRatings = this.Ratings.sort((a, b) => a.rating - b.rating);
      const sortedKPIS = kpis.sort((a, b) => a.score.rating - b.score.rating);
      this.Ratings = sortedRatings;
      // eslint-disable-next-line no-param-reassign
      kpis = sortedKPIS;
      this.Ratings.map((rating, index) => {
        criteriaData.push({
          id: kpis[index].id,
          performanceRatingId: rating.id,
          criteria: kpis[index].criteria,
        });
        return {};
      });
      return criteriaData;
    },

    checkAppraisalStart() {
      const today = new Date();

      this.appraisalEndDate.setDate(this.appraisalEndDate.getDate() + 1);

      if (today >= this.appraisalStartDate && today <= this.appraisalEndDate) {
        this.startAppraisal = true;
      } else if (
        today < this.appraisalStartDate &&
        today <= this.appraisalEndDate
      ) {
        this.startAppraisal = false;
        this.appraisalMessage = `${this.activeTab} appraisal starts on the
                          ${this.$DATEFORMAT(
                            new Date(this.appraisalStartDate),
                            "MMMM dd, yyyy"
                          )}. You will be notified when it begins.`;
      } else {
        this.startAppraisal = true;
        this.appraisalMessage = "";
        this.appraisalEnd = true;
      }

      this.getEmployeeAppraisal();
    },
    async getCycleTabs() {
      try {
        this.tabsItems = [];

        const response = await this.$_getAppraisalCycle(this.appraisalQuery());
        const appraisal = response.data.AppraisalCycle;

        const appraisalCycle = appraisal[0].cycles.sort(
          (a, b) =>
            this.setDates(a.appraisal_starts) -
            this.setDates(b.appraisal_starts)
        );

        this.tabsItems = appraisalCycle.map(({ name }) => name);
        this.tabsItems.push("Status Overview");
      } catch (error) {
        console.error("Error fetching cycles:", error);
      }
    },
    getSettings() {
      this.$_getPerformanceGeneralSetting().then((response) => {
        response.data.PerformanceSettings.map((setting) => {
          const appraisalByWho = setting.appraisailScoringPreference;
          this.checkEditAppraisal = setting.managerCanEditEmployeeAppraisal;
          this.midTermAppraisalStructure =
            response.data.PerformanceSettings[0].midTermAppraisalMethod;
          if (appraisalByWho === "manager_to_appraisee") {
            this.appraisalDisplay = "manager";
            this.KPAHeader.push(
              {
                title: "First Line Manager’s Rating",
                value: "managerRating",
              },
              {
                title: "Performance Outcome",
                value: "outcome",
              }
            );
          } else if (appraisalByWho === "employee_self_appraisal") {
            this.appraisalDisplay = "employee";
            this.KPAHeader.push(
              {
                title: "Self Rating",
                value: "selfRating",
              },
              {
                title: "Performance Outcome",
                value: "outcome",
              }
            );
          } else if (appraisalByWho === "both") {
            this.appraisalDisplay = "both";
            this.KPAHeader.push(
              {
                title: "Self Rating",
                value: "selfRating",
              },
              {
                title: "First Line Manager’s Rating",
                value: "managerRating",
              },
              {
                title: "Performance Outcome",
                value: "outcome",
              }
            );
          }
          return {};
        });
      });
    },

    getUser() {
      this.$_getUser(this.$AuthUser.id).then((result) => {
        this.loadingData = false;
        if (result.data.user.userDesignation.reportingTo !== null) {
          this.employee = true;
        } else {
          this.employee = false;
        }
      });
    },

    formatCommentTime(date) {
      const newDate = new Date(date);
      const hours = newDate.getUTCHours();
      const minutes = newDate.getMinutes();
      return `${1 + ((hours - 1) % 12)}:${minutes
        .toString()
        .padStart(2, "0")} ${hours > 11 ? "PM" : "AM"}`;
    },

    getEachAgreementComments(agreementId) {
      this.allComments = [];
      this.senderkpaId = agreementId;
      const kpi = agreementId ? `?kpiId=${agreementId}` : "";
      this.loadComments = true;
      if (agreementId) {
        this.$_getEachAgreementComments(kpi)
          .then((response) => {
            const { comments } = response.data;

        this.allComments = comments;
        this.isOpenComments = true;
        this.loadComments = false;
        }).catch((error) => {
          this.loadComments = false;
        this.senderkpaId = '';
        this.$toasted.error('Error getting comments', { duration: 5000 });
        });
      }
    },
    viewReport(kpasItem, kpaTypes) {
      this.statusModal = true;
      this.kpasItem = kpasItem;
      this.kpaTypes = kpaTypes;
    },
    async sendComment() {
      this.isSavingComment = true;
      try {
        await this.$handlePrivilege("performanceAppraisals", "makeComment");
        const payload = {
          performanceAgreementId: this.payload.employeeAgreementId,
          senderId: this.$AuthUser.id,
          receiverId: this.$AuthUser.id,
          comment: this.comment,
          sendTo: "admin",
        };
        this.$_postAgreementComments(payload).then((response) => {
          this.isOpenComments = false;
          this.isSavingComment = false;
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.comment = "";
        });
      } catch (error) {
        this.isOpenComments = false;
        this.isSavingComment = false;
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    markAsRead(commentId) {
      const payload = {
        commentId,
        readStatus: true,
      };
      this.$_markAsRead(payload)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
        })
        .catch((err) => {
          this.$toasted.error(err.response.data.message, { duration: 5000 });
        });
    },

    getAppraisalFlags() {
      this.$_getAppraisalFlag().then((response) => {
        const { flags } = response.data;
        flags.forEach((flag) => {
          this.flagOptions.push({
            id: flag.id,
            name: flag.name,
          });
        });
      });
    },
    goBackToDirectReport() {
      this.$router.push({
        name: "PerformanceAppraisalDetail",
        params: {
          year: this.directReportYear,
          cycleId: this.directReportId,
          QAppraisal: this.QAppraisal,
        },
      });
    },
  },

  async mounted() {
    try {
      await this.$handlePrivilege(
        "performanceAppraisals",
        "viewEmployeeAppraisal"
      );
      this.hasModuleAccess = true;

      if (this.$route.params.user === this.$AuthUser.id) {
        this.payload.appraisalFor = this.$AuthUser.id;
        this.payload.appraisalBy = this.$AuthUser.id;
        this.payload.employeeId = this.$AuthUser.id;
      } else {
        this.payload.appraisalFor = this.$route.params.user;
        this.payload.appraisalBy = this.$AuthUser.id;
        this.payload.employeeId = this.$route.params.user;
      }

      this.$_getPerfomanceRating().then((response) => {
        this.Ratings = response.data.PerformanceRatings;

        response.data.PerformanceRatings.map((ratings) => {
          this.ratingOptions.push({
            id: ratings.id,
            name: ratings.rating,
          });
          return {};
        });
      });
      this.$_getPerformanceGeneralSetting().then((response) => {
        this.dottedReportingAppraisal =
          response.data.PerformanceSettings[0].appraisalReviewer.includes(
            "dotted_line_managers"
          );
      });
      this.getSettings();
      this.getCycleTabs();
      this.getUser();
      this.getAppraisalFlags();

      this.getUserDetails();
    } catch (error) {
      this.hasModuleAccess = false;
    }
  },
};
</script>

<style>
.input-select {
  border: 1px solid #878e99;
  height: 38px;
  padding: 10px 15px;
  width: 100%;
  border-radius: 5px;
  color: #321c3b;
  line-height: 120%;
  letter-spacing: 0.015em;
}

.input-select:focus {
  outline: none;
}

.input-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(/img/down-arrow.f3bc3f05.svg);
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 14px;
  padding: 3px 15px;
  width: 100%;
  padding-right: 29px;
  outline: none;
  border: 1px solid #878e99;
  box-sizing: border-box;
  border-radius: 3px;
  height: 40px;
  /* width: 100%; */
  /* width: fit-content; */
}
</style>
